'use strict';

angular.module('AcaApp').controller('Form1094CController',
[
  '$scope',
  '$mdDialog',
  'EmployerService',
  'ShortcutsService',
  'LayoutService',
  'FormService',
  'UtilsService',
  'FORM_MESSAGES',
  '$location',
  '$route',
  '$timeout',
  'currentEmployer',
  'MsgBetweenCtrlService',
  '$q',
  'CONSTANTS',
  '$window',
  //jscs:disable maximumLineLength
  function($scope, $mdDialog, EmployerService, ShortcutsService, LayoutService, FormService, UtilsService, FORM_MESSAGES, $location, $route, $timeout, currentEmployer, MsgBetweenCtrlService, $q, CONSTANTS, $window){
    var dataController = (MsgBetweenCtrlService.data.parent !== undefined && MsgBetweenCtrlService.data.parent.selectedEmployer !== undefined) ? MsgBetweenCtrlService.data.parent : undefined;
    ShortcutsService.disableBackSpaceDefault();
    $scope.states = UtilsService.getStates();
    $scope.formStep = 'save';
    $scope.aleVersion = '';
    $scope.taxyear = $window.sessionStorage.taxYear;
    $scope.idItem = 0;
    var oldGroup = {
      aleGroup: undefined
    };
    var questions = [];
    $scope.data = {
      optionOne: undefined,
      optionTwo: undefined,
      optionThree: undefined,
      optionFour: undefined
    };
    $scope.setQuestions = function(currentEmployer){
      var payers = $scope.payers;
      var filtersPayer = _.where(payers, {ptin: $scope.form.ptin});
      if(filtersPayer[0] !== undefined &&filtersPayer[0].userdefined1 !== undefined) {
        questions = filtersPayer[0].userdefined1.split(',');
        $scope.data.optionOne = (questions[0] == '1') ? 'true' : 'false';
        $scope.data.optionTwo = (questions[1] == '1') ? 'true' : 'false';
        $scope.data.optionThree = (questions[2] == '1') ? 'true' : 'false';
        $scope.data.optionFour = (questions[3] == '1') ? 'true' : 'false';
      }
      else{
        if(currentEmployer !== undefined && currentEmployer.userdefined1 !== undefined) {
          questions = currentEmployer.userdefined1.split(',');
          $scope.data.optionOne = (questions[0] == '1') ? 'true' : 'false';
          $scope.data.optionTwo = (questions[1] == '1') ? 'true' : 'false';
          $scope.data.optionThree = (questions[2] == '1') ? 'true' : 'false';
          $scope.data.optionFour = (questions[3] == '1') ? 'true' : 'false';
        }
        else{
          $scope.data.optionOne = undefined;
          $scope.data.optionTwo = undefined;
          $scope.data.optionThree = undefined;
          $scope.data.optionFour = undefined;
        }
      }
    };

    if(currentEmployer !== undefined){
      $scope.form = currentEmployer;
      $scope.setQuestions(currentEmployer);
    }
    else{
      $scope.form = {};
    }
    $scope.fields = {
      validDate: true,
      validPin: true,
      validPinNumber: true,
      validDateCurrent: true,
      validContact: true,
      validContactphone: true,
      validEIN: true,
      validTECount: false,
      validFECount: false,
      validMECIndicator: false,
      validAGIndicator: false,
      validNOAGIndicator: false,
      validS4TrIndicator: false,
      validNOS4TrIndicator: false,
      validTotalFormsFiled: false,
      validGovtEntityEmployer: false,
      validDataGovtEntityEmployer: false,
      messageDate: '',
      messagePin: '',
      messagePinNumber: '',
      messageDateCurrent: '',
      messageContact: '',
      messageContactphone: '',
      messageTECount: '',
      messageFECount: '',
      messageMECIndicator: '',
      messageAGIndicator: '',
      messageNOAGIndicator: '',
      messageS4TrIndicator: '',
      messageNOS4TrIndicator: '',
      messageTotalFormsFiled: '',
      messageGovtEntityEmployer: '',
      messageDataGovtEntityEmployer: ''
    };
    $scope.monthly = {value: 'true'};
    $scope.formPage = '';
    $scope.internalParI = false;
    $scope.internalParII = false;
    $scope.internalParIII = false;
    $scope.mecWarning = true;
    $scope.internalParIV = false;
    $scope.internalPar0 = false;
    $scope.aleGroups = [];
    $scope.x5cTotalForms;
    $scope.isBox20readonly = true;
    var numberALEGroup = 36;
    $scope.arrayMonthly = [
      {monthly: 'January',prefix: 'jan'},
      {monthly: 'February', prefix: 'feb'},
      {monthly: 'March', prefix: 'mar'},
      {monthly: 'April', prefix: 'apr'},
      {monthly: 'May', prefix: 'may'},
      {monthly: 'June', prefix: 'jun'},
      {monthly: 'July', prefix: 'jul'},
      {monthly: 'August', prefix: 'aug'},
      {monthly: 'September', prefix: 'sep'},
      {monthly: 'October', prefix: 'oct'},
      {monthly: 'November', prefix: 'nov'},
      {monthly: 'December', prefix: 'dec'}
    ];
    $scope.addItem = function(){
      var item = {
        number: numberALEGroup,
        name: '',
        ein: '',
        ALEEINRequired: false,
        ALENameRequired: false
      };
      $scope.aleGroups.push(item);
      numberALEGroup++;
    };
    $scope.deleteItem = function(id){
      $scope.idItem = id;
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/form/modals/delete-alegroup.html',
        parent: angular.element(document.body)
      });
    };
    $scope.deleteAleMember = function(){
      for(var i = 0; i < $scope.aleGroups.length; i++){
        if($scope.aleGroups[i].number === $scope.idItem){
          if($scope.aleGroups[i].recordversion !== undefined){
            FormService.DeleteAleMember($scope.aleGroups[i]).then(function(){
              $scope.show1094CModal();
              $timeout(function(){
                EmployerService.GetEmployerByPk($scope.form.ptin).then(function(data){
                  $scope.form.recordversion = data.result.recordversion;
                });
              }, 1000);
            },
            function(error){
              $scope.ErrorMsg(error);
            });
          }
          else{
            $scope.show1094CModal();
          }
          $scope.aleGroups.splice(i, 1);
          oldGroup.aleGroup.splice(i, 1);
        }
      }
      numberALEGroup = 36;
      for(i = 0; i < $scope.aleGroups.length; i++){
        $scope.aleGroups[i].number = numberALEGroup;
        numberALEGroup++;
      }
    };
    $scope.show1094CModal = function(){
      $mdDialog.show({
        templateUrl: 'app/views/form/modals/form1094C.html',
        preserveScope: true,
        scope: $scope
      });
    };
    var changePage = function(value){
      $scope.formPage = value;
    };
    var setErrorMessage = function(value){
      $scope.errorMessage = value;
    };
    EmployerService.getPayerList().then(function(data){
      $scope.payers = data.result;
    },
    function(error){
      /* jscs:disable requireCamelCaseOrUpperCaseIdentifiers */
      $scope.errorMessage = (error.data.error.frontend_message || undefined);
    });
    $scope.closeModal = function(){
      ShortcutsService.enableBackSpaceDefault();
      $mdDialog.hide();
    };
    $scope.validateMandatory = function(){
      if(!$scope.form.ptin){
        setErrorMessage(FORM_MESSAGES.INCOMPLETE);
        return true;
      }
      else{
        setErrorMessage('');
        return false;
      }
    };
    var validateOptions = function(){
      if($scope.data.optionOne === undefined ||
          $scope.data.optionTwo === undefined ||
          ($scope.data.optionTwo === 'true' &&
          ($scope.data.optionThree === undefined ||
          $scope.data.optionFour === undefined))){
        setErrorMessage(FORM_MESSAGES.INCOMPLETE);
        return true;
      }
      else{
        $scope.errorMessage = '';
        return false;
      }
    };

    $scope.checkMECIndicator = function(form1094C){
      $scope.mecWarning = false;
      var showMECIndicatorModal = false;
      if($scope.monthly.value === 'true'){
        if(replaceValue($scope.form.all_mecoindicator) === '0'){
          showMECIndicatorModal = true;
        }
      }else{
        _.each($scope.form, function(value, key){
          if (key.endsWith('_mecoindicator') && replaceValue(value) === '0'){
            showMECIndicatorModal = true;
          }
        });
      }
      if(showMECIndicatorModal){
        $scope.form1094C = form1094C;
        $mdDialog.show({
          scope: $scope,
          preserveScope: true,
          templateUrl: 'app/views/form/partials/MECWarning.html',
          parent: angular.element(document.body)
        });
        return false;
      }
      return true;
    };

    $scope.saveAfterMECWarning = function(){
      $scope.save($scope.form1094C);
    };

    $scope.checkStepOne = function(){
      if(($scope.data.optionTwo !== 'true') && (questions[1] === '1')){
        changePage('confirmationStep2');
      } 
      else if(($scope.data.optionFour !== 'true') && (questions[3] === '1')){
        changePage('confirmationStep4');
      }
      else $scope.nexStep();
    };
    $scope.nexStep = function(sectionToClear){
      if(!$scope.validateMandatory() && !validateOptions()){
        $scope.internalParI = ($scope.data.optionOne === 'true');
        $scope.internalParII = ($scope.data.optionTwo === 'true');
        $scope.internalParIII = ($scope.data.optionTwo === 'true');
        $scope.internalParIV = ($scope.data.optionFour === 'true' && $scope.data.optionTwo === 'true');
        $scope.internalPar0 = ($scope.data.optionOne === 'false' && $scope.data.optionTwo === 'false');
        if($scope.internalParIV === true && $scope.aleGroups.length === 0){
          $scope.addItem();
        }
        $scope.isBox20readonly = ($scope.data.optionThree === 'true');
        $q.all([
          FormService.getX5CRecordsCountByEmployer($scope.form.ptin),
          EmployerService.GetEmployerByPk($scope.form.ptin),
          FormService.GetAleMonthlyByEmployer($scope.form.ptin),
          FormService.GetAleGroupByEmployer($scope.form.ptin)
          ]).then(function(data){
          if(data[1].result != undefined && ($scope.internalParI || !$scope.internalPar0)){
            data[1].result.x4c_signaturedate = checkSignatureDate(data[1].result.x4c_signaturedate);
            $scope.form = data[1].result;
            $scope.form.x4c_qlfyoffermethodind = assignValueBool($scope.form.x4c_qlfyoffermethodind);
            $scope.form.x4c_qlfyoffermethodtrind = assignValueBool($scope.form.x4c_qlfyoffermethodtrind);
            $scope.form.x4c_pctoffermethodind = assignValueBool($scope.form.x4c_pctoffermethodind);
            $scope.form.x4c_sect4980hreliefind = assignValueBool($scope.form.x4c_sect4980hreliefind);
            $scope.monthly = {value: 'true'};
            $timeout(function(){
              if($scope.form.x4c_govtentityemployer !== undefined){
                LayoutService.setSelectBoxChange('#dge-selected', $scope.form.x4c_govtentityemployer, '#dge-label');
              }
              LayoutService.addDatepicker('#signaturedate');
            }, 1000);
          }
          if(data[0].result && $scope.internalParII && ($scope.isBox20readonly || !$scope.form.x4c_totalformsfiled)){
            $scope.form.x4c_totalformsfiled = data[0].result.value;
          }
          if(data[2].result.length > 0 && $scope.internalParII){
            $scope.monthly = {value: 'false'};
            getMonthly(data[2].result[0]);
            $scope.formStep = 'update';
            $scope.aleVersion = data[2].result[0].recordversion;
          }
          if(data[3].result.length > 0 && $scope.internalParIV){
            $scope.aleGroups = angular.copy(data[3].result);
            oldGroup.aleGroup = angular.copy(data[3].result);
            $scope.formStep = 'update';
            numberALEGroup = 36;
            for(var i = 0; i < $scope.aleGroups.length; i++){
              $scope.aleGroups[i].number = numberALEGroup;
              numberALEGroup++;
            }
          }
          if(data[1].result != undefined && $scope.internalPar0){
            data[1].result.x4c_signaturedate = checkSignatureDate(data[1].result.x4c_signaturedate);
            $scope.form = data[1].result;
            $scope.form.x4c_qlfyoffermethodind = assignValueBool($scope.form.x4c_qlfyoffermethodind);
            $scope.form.x4c_qlfyoffermethodtrind = assignValueBool($scope.form.x4c_qlfyoffermethodtrind);
            $scope.form.x4c_pctoffermethodind = assignValueBool($scope.form.x4c_pctoffermethodind);
            $scope.form.x4c_sect4980hreliefind = assignValueBool($scope.form.x4c_sect4980hreliefind);
          }
          if(sectionToClear != undefined){
            // PART IV
            FormService.deleteAleGroupMembers($scope.form.ptin).then();
          }
          if(sectionToClear == 'SECTION2'){
            // PART III
            FormService.deleteAleMonthlyMembers($scope.form.ptin).then(function(){
              // PART II
              $scope.form.x4c_signaturepin = '';
              $scope.form.x4c_signaturetitle = '';
              $scope.form.x4c_signaturedate = '';
              $scope.form.x4c_totalformsfiled = '';
              $scope.form.x4c_qlfyoffermethodind = null;
              $scope.form.x4c_qlfyoffermethodtrind = null;
              $scope.form.x4c_sect4980hreliefind = null;
              $scope.form.x4c_pctoffermethodind = null;
            });
          }
        },
        function(error){
          console.log('Error', error);
        });
        changePage('secondStep');
      }
    };
    $scope.goStepOne = function(){
      $scope.form = {
        ptin: $scope.form.ptin
      };
      $scope.errorMessage = '';
      changePage('firstStep');
      $scope.aleGroups = [];
      numberALEGroup = 36;
      $scope.formStep = 'save';
    };
    $scope.evaluate = function(value1, value2){
      return LayoutService.selectedItemToUpperCase(value1, value2);
    };
    $scope.validateFields = function(field, requiredField){
      if(requiredField){
        if((field === 'editALEName' || !field) && !requiredField.name){
          requiredField.ALENameRequired = true;
        }
        else{
          requiredField.ALENameRequired = false;
        }
        if((field === 'editALEEIN' || !field) && !requiredField.ein){
          requiredField.ALEEINRequired = true;
        }
        else{
          requiredField.ALEEINRequired = false;
        }
      }
      if(field === 'editEin'){
        $scope.einRequired = true;
      }
      if(field === 'editStreetAddress'){
        $scope.streetAddressRequired = true;
      }
      if(field === 'editCity'){
        $scope.cityRequired = true;
      }
      if(field === 'editState'){
        $scope.stateRequired = true;
      }
      if(field === 'editZip'){
        $scope.zipRequired = true;
      }
      if(field === 'editNameContact' || !field){
        $scope.nameContactRequerid = true;
      }
      if(field === 'editPhoneContact' || !field){
        $scope.phoneContactRequerid = true;
      }
      $scope.errorMessage = '';
    };
    $scope.save = function(form1094C){
      setErrorMessage(undefined);
      if(form1094C.$valid) {
        $scope.fields.validTECount = false;
        $scope.fields.validFECount = false;
        $scope.fields.validMECIndicator = false;
        $scope.fields.validAGIndicator = false;
        $scope.fields.validNOAGIndicator = false;
        $scope.fields.validS4TrIndicator = false;
        $scope.fields.validNOS4TrIndicator = false;
        $scope.fields.validTotalFormsFiled = false;
        $scope.fields.validGovtEntityEmployer = false;
        $scope.fields.validDataGovtEntityEmployer = false;
        checkFields();
        if($scope.taxyear >= '2016') {
          checkFields16();
        }
        else{
          $scope.fields.validMECIndicator = true;
          $scope.fields.validFECount = true;
          $scope.fields.validAGIndicator = true;
          $scope.fields.validNOAGIndicator = false;
          $scope.fields.validS4TrIndicator = false;
          $scope.fields.validNOS4TrIndicator = false;
          $scope.fields.validTotalFormsFiled = true;
          $scope.fields.validGovtEntityEmployer = true;
          $scope.fields.validDataGovtEntityEmployer = true;
        }
        if(validCondition()) {
          if($scope.internalParIII && $scope.mecWarning) {
            var continueWithSave = $scope.checkMECIndicator(form1094C);
            if (!continueWithSave) return;
          };

          var rpcForm = {
            payer: undefined,
            aleMonthly: undefined,
            aleGroup: undefined
          };

          //PartI
          if($scope.internalParI === true) {
            rpcForm.payer = {};
            rpcForm.payer.ptin = $scope.form.ptin;
            getPayer(rpcForm.payer);
            rpcForm.payer.x4c_govtentityemployer = $scope.form.x4c_govtentityemployer;
            rpcForm.payer.contact = $scope.form.contact;
            rpcForm.payer.contactphone = $scope.form.contactphone;
            rpcForm.payer.x4c_signaturedate = ($scope.form.x4c_signaturedate !== '') ? $scope.form.x4c_signaturedate : null;
          }
          //Part II
          if($scope.internalParII === true) {
            if($scope.form.x4c_signaturetitle !== undefined && $scope.form.x4c_signaturetitle !== '') {
              $scope.form.x4c_signaturetitle = $scope.form.x4c_signaturetitle.replace(/ +/g, ' ');
            }
            rpcForm.payer = rpcForm.payer || {};
            rpcForm.payer.ptin = $scope.form.ptin;
            getPayer(rpcForm.payer);
            rpcForm.payer.contact = $scope.form.contact;
            rpcForm.payer.contactphone = $scope.form.contactphone;
            rpcForm.payer.x4c_signaturepin = $scope.form.x4c_signaturepin;
            rpcForm.payer.x4c_signaturetitle = $scope.form.x4c_signaturetitle;
            rpcForm.payer.x4c_signaturedate = ($scope.form.x4c_signaturedate !== '') ? $scope.form.x4c_signaturedate : null;
            rpcForm.payer.x4c_totalformsfiled = $scope.form.x4c_totalformsfiled;
            rpcForm.payer.x4c_qlfyoffermethodind = ($scope.form.x4c_qlfyoffermethodind === true) ? '1' : '0';
            rpcForm.payer.x4c_qlfyoffermethodtrind = ($scope.form.x4c_qlfyoffermethodtrind === true) ? '1' : '0';
            rpcForm.payer.x4c_sect4980hreliefind = ($scope.form.x4c_sect4980hreliefind === true) ? '1' : '0';
            rpcForm.payer.x4c_pctoffermethodind = ($scope.form.x4c_pctoffermethodind === true) ? '1' : '0';
          }
          //Part III
          if($scope.internalParIII === true){
            rpcForm.aleMonthly = {};
            setMonthly(rpcForm.aleMonthly);
            rpcForm.aleMonthly.recordversion = $scope.aleVersion;
          }
          //Part IV
          if($scope.internalParIV === true){
            if($scope.aleGroups.length > 0){
              for(var i = 0; i < $scope.aleGroups.length; i++){
                $scope.aleGroups[i].ptin = $scope.form.ptin;
              }
              rpcForm.aleGroup = $scope.aleGroups;
            }
          }
          //Part0
          if($scope.internalPar0 === true) {
            rpcForm.payer = {};
            rpcForm.payer.ptin = $scope.form.ptin;
            getPayer(rpcForm.payer);
            rpcForm.payer.x4c_govtentityemployer = $scope.form.x4c_govtentityemployer;
            rpcForm.payer.contact = $scope.form.contact;
            rpcForm.payer.contactphone = $scope.form.contactphone;
            rpcForm.payer.x4c_signaturedate = ($scope.form.x4c_signaturedate !== '') ? $scope.form.x4c_signaturedate : null;
          }
          if(rpcForm.payer !== undefined){
            rpcForm.payer.userdefined1 = getQuestions(rpcForm.payer);
            rpcForm.payer.x4c_xmitrun = $scope.form.x4c_xmitrun;
            rpcForm.payer.x4c_status = $scope.form.x4c_status;
            rpcForm.payer.pshortname = $scope.form.pshortname;
            rpcForm.payer.paddress2 = $scope.form.paddress2;
            rpcForm.payer.pname2 = $scope.form.pname2;
            rpcForm.payer.rescountrycode = $scope.form.rescountrycode;
            rpcForm.payer.pforeignprovince = $scope.form.pforeignprovince;
            rpcForm.payer.pfax = $scope.form.pfax;
            rpcForm.payer.phone = $scope.form.phone;
            rpcForm.payer.pstate = $scope.form.pstate;
            rpcForm.payer.pzip = $scope.form.pzip;
          }
          if($scope.formStep === 'save'){
            save1094(rpcForm);
          }
          else{
            update(rpcForm, oldGroup);
          }
        }
        else{
          var errorMessage = !($scope.fields.validDate) ? $scope.fields.messageDate + '\n' : '';
          errorMessage += !($scope.fields.validPin) ? $scope.fields.messagePin + '\n' : '';
          errorMessage += !($scope.fields.validPinNumber) ? $scope.fields.messagePinNumber + '\n' : '';
          errorMessage += !($scope.fields.validDateCurrent) ? $scope.fields.messageDateCurrent + '\n' : '';
          errorMessage += !($scope.fields.validContact) ? $scope.fields.messageContact + '\n' : '';
          errorMessage += !($scope.fields.validContactphone) ? $scope.fields.messageContactphone + '\n' : '';
          errorMessage += !($scope.fields.validTECount) ? $scope.fields.messageTECount + '\n' : '';
          errorMessage += !($scope.fields.validMECIndicator) ? $scope.fields.messageMECIndicator + '\n' : '';
          errorMessage += !($scope.fields.validFECount) ? $scope.fields.messageFECount + '\n' : '';
          errorMessage += !($scope.fields.validAGIndicator) ? $scope.fields.messageAGIndicator + '\n' : '';
          errorMessage += ($scope.fields.validNOAGIndicator) ? $scope.fields.messageNOAGIndicator + '\n' : '';
          if($scope.taxyear < '2017'){
            errorMessage += ($scope.fields.validS4TrIndicator) ? $scope.fields.messageS4TrIndicator + '\n' : '';
            errorMessage += ($scope.fields.validNOS4TrIndicator) ? $scope.fields.messageNOS4TrIndicator + '\n' : '';
          }
          errorMessage += !($scope.fields.validTotalFormsFiled) ? $scope.fields.messageTotalFormsFiled + '\n' : '';
          errorMessage += !($scope.fields.validGovtEntityEmployer) ? $scope.fields.messageGovtEntityEmployer + '\n' : '';
          errorMessage += !($scope.fields.validDataGovtEntityEmployer) ? $scope.fields.messageDataGovtEntityEmployer + '\n' : '';
          errorMessage += !($scope.fields.validEIN) ? $scope.fields.messageEIN + '\n' : '';
          setErrorMessage(errorMessage);
        }
      }
      else{
        setErrorMessage(FORM_MESSAGES.INCOMPLETE);
      }
    };

    var validCondition = function(){
      return (
        $scope.fields.validPin &&
        $scope.fields.validDate &&
        $scope.fields.validPinNumber &&
        $scope.fields.validDateCurrent &&
        $scope.fields.validContact &&
        $scope.fields.validContactphone &&
        $scope.fields.validTECount &&
        $scope.fields.validMECIndicator &&
        $scope.fields.validFECount &&
        $scope.fields.validAGIndicator &&
        !$scope.fields.validNOAGIndicator &&
        !$scope.fields.validS4TrIndicator &&
        !$scope.fields.validNOS4TrIndicator &&
        $scope.fields.validTotalFormsFiled &&
        $scope.fields.validGovtEntityEmployer &&
        $scope.fields.validDataGovtEntityEmployer &&
        $scope.fields.validEIN
      );
    };

    var save1094 = function(rpcForm){
      FormService.save1094c(rpcForm).then(
        function(){
          $mdDialog.hide();
          $mdDialog.show({
            controller: [
              '$scope',
              function($scope){
                $scope.titleUI = 'Creation';
                $scope.descriptionUI = 'created';
                $scope.formType = 'C';
                $scope.closeModal = function(){
                  ShortcutsService.enableBackSpaceDefault();
                  $mdDialog.hide();
                  reloadEmployer();
                };
              }
            ],
            templateUrl: 'app/views/form/modals/add1094CSuccessMessage.html'
          });
        },
        function(error){
          setErrorMessage(error.data.error.frontend_message);
        }
      );
    };

    var update = function(rpcForm, oldGroup){
      FormService.update1094c(rpcForm, oldGroup).then(
        function(){
          $mdDialog.hide();
          $mdDialog.show({
            controller: [
              '$scope',
              function($scope){
                $scope.titleUI = 'Update';
                $scope.descriptionUI = 'updated';
                $scope.formType = 'C';
                $scope.closeModal = function(){
                  ShortcutsService.enableBackSpaceDefault();
                  $mdDialog.hide();
                  reloadEmployer();
                };
              }
            ],
            templateUrl: 'app/views/form/modals/add1094CSuccessMessage.html'
          });
        },
        function(error){
          setErrorMessage(error.data.error.frontend_message);
        }
      );
    };

    $scope.changeValueThreeAndFour = function(event){
      if(event.currentTarget.children[0].attributes[4].value === 'false') {
        $scope.data.optionThree = 'false';
        $scope.data.optionFour = 'false';
      }
    };

    var reloadEmployer = function(){
     var path = (currentEmployer || {}).path;
     if(path){
       return;
     }
     $location.path('records').search({section: 'recordEmployer'});
     $route.reload();
    };

    var setMonthly = function(rpcForm){
      rpcForm.ptin = $scope.form.ptin;
      if($scope.monthly.value === 'true'){
        _.each($scope.arrayMonthly, function(element){
          rpcForm[element.prefix + '_mecoindicator'] = replaceValue($scope.form.all_mecoindicator);
          rpcForm[element.prefix + '_fecount'] = ($scope.form.all_fecount === undefined) ? CONSTANTS.INTEGER_NULL : $scope.form.all_fecount;
          rpcForm[element.prefix + '_tecount'] = ($scope.form.all_tecount === undefined) ? CONSTANTS.INTEGER_NULL : $scope.form.all_tecount;
          rpcForm[element.prefix + '_agindicator'] = replaceValue($scope.form.all_agindicator);
          rpcForm[element.prefix + '_s4trindicator'] = $scope.form.all_s4trindicator;
        });
      }
      else{
        _.each($scope.arrayMonthly, function(element){
          rpcForm[element.prefix + '_mecoindicator'] = replaceValue($scope.form[element.prefix + '_mecoindicator']);
          rpcForm[element.prefix + '_fecount'] = ($scope.form[element.prefix + '_fecount'] === null || $scope.form[element.prefix + '_fecount'] === undefined) ? CONSTANTS.INTEGER_NULL : $scope.form[element.prefix + '_fecount'];
          rpcForm[element.prefix + '_tecount'] = ($scope.form[element.prefix + '_tecount'] === null || $scope.form[element.prefix + '_tecount'] === undefined) ? CONSTANTS.INTEGER_NULL : $scope.form[element.prefix + '_tecount'];
          rpcForm[element.prefix + '_agindicator'] = replaceValue($scope.form[element.prefix + '_agindicator']);
          rpcForm[element.prefix + '_s4trindicator'] = $scope.form[element.prefix + '_s4trindicator'];
        });
      }
    };

    var getMonthly = function(rpcForm){
      rpcForm.ptin = $scope.form.ptin;
      if($scope.monthly.value === 'true'){
        _.each($scope.arrayMonthly, function(element){
          $scope.form[element.prefix + '_mecoindicator'] = assignValue(rpcForm.all_mecoindicator);
          $scope.form[element.prefix + '_fecount'] = rpcForm.all_fecount;
          $scope.form[element.prefix + '_tecount'] = rpcForm.all_tecount;
          $scope.form[element.prefix + '_agindicator'] = assignValueBool(rpcForm.all_agindicator);
          $scope.form[element.prefix + '_s4trindicator'] = rpcForm.all_s4trindicator;
        });
      }
      else{
        _.each($scope.arrayMonthly, function(element){
          $scope.form[element.prefix + '_mecoindicator'] = assignValue(rpcForm[element.prefix + '_mecoindicator']);
          $scope.form[element.prefix + '_fecount'] = rpcForm[element.prefix + '_fecount'];
          $scope.form[element.prefix + '_tecount'] = rpcForm[element.prefix + '_tecount'];
          $scope.form[element.prefix + '_agindicator'] = assignValueBool(rpcForm[element.prefix + '_agindicator']);
          $scope.form[element.prefix + '_s4trindicator'] = rpcForm[element.prefix + '_s4trindicator'];
        });
      }
    };

    var replaceValue = function(value){
      return (value !== undefined && (value === true || value === 'true')) ? '1' : '0';
    };
    var assignValue = function(value){
      return (value !== undefined && value === '1') ? 'true' : 'false';
    };
    var assignValueBool = function(value){
      return (value !== undefined && (value === 'Y' || value === '1')) ? true : false;
    };
    var getQuestions = function(rpc){
      var questionOne = ($scope.data.optionOne === 'true') ? '1' : '0';
      var questionTwo = rpc.x4c_authoritativexmitind = ($scope.data.optionTwo === 'true') ? '1' : '0';
      var questionThree = ($scope.data.optionThree === 'true') ? '1' : '0';
      var questionFour = rpc.x4c_aggrgroupmemberind = ($scope.data.optionFour === 'true') ? '1' : '0';
      return (questionOne + ',' + questionTwo + ',' + questionThree + ',' + questionFour);
    };
    var getPayer = function(rpc){
      rpc.ptin = $scope.form.ptin;
      rpc.ptintype = $scope.form.ptintype;
      rpc.recordversion = $scope.form.recordversion;
      rpc.modlevel = $scope.form.modlevel;
      rpc.modid = $scope.form.modid;
      rpc.x4c_pctoffermethodind = $scope.form.x4c_pctoffermethodind ? '1' : '0';
      rpc.x4c_qlfyoffermethodind = $scope.form.x4c_qlfyoffermethodind ? '1' : '0';
      rpc.x4c_qlfyoffermethodtrind = $scope.form.x4c_qlfyoffermethodtrind ? '1' : '0';
      rpc.x4c_sect4980hreliefind = $scope.form.x4c_sect4980hreliefind ? '1' : '0';
      rpc.x4b_signaturedate = ($scope.form.x4b_signaturedate !== undefined && $scope.form.x4b_signaturedate !== '') ? $scope.form.x4b_signaturedate : null;
      rpc.x4b_signaturepin = ($scope.form.x4b_signaturepin !== undefined && $scope.form.x4b_signaturepin !== '') ? $scope.form.x4b_signaturepin : null;
      rpc.x4b_signaturetitle = ($scope.form.x4b_signaturetitle !== undefined && $scope.form.x4b_signaturetitle !== '') ? $scope.form.x4b_signaturetitle : null;
    };

    var checkSignatureDate = function(date){
      return (date !== undefined) ? UtilsService.getUnixTimestamp(date).split(' ')[0] : '';
    };

    $scope.checkNumber = function(event){
      return UtilsService.checkCharacter(event);
    };

    $scope.checkName = function(event){
      return UtilsService.checkAlphaCharacter(event);
    };

    var checkFields = function(){
      if($scope.form.x4c_signaturedate !== undefined && $scope.form.x4c_signaturedate !== '') {
        $scope.fields.validDate = UtilsService.checkValidDate($scope.form.x4c_signaturedate);
        $scope.fields.messageDate = !($scope.fields.validDate) ? FORM_MESSAGES.INVALIDDATE : '';
        $scope.fields.validDateCurrent = UtilsService.checkMostDateCurrent($scope.form.x4c_signaturedate);
        $scope.fields.messageDateCurrent = !($scope.fields.validDateCurrent) ? FORM_MESSAGES.MOSTDATECURRENTC : '';
      }
      if($scope.form.x4c_signaturepin !== undefined && $scope.form.x4c_signaturepin !== '') {
        $scope.fields.validPin = UtilsService.checkTenCharacters($scope.form.x4c_signaturepin);
        $scope.fields.messagePin = !($scope.fields.validPin) ? FORM_MESSAGES.INVALIDPIN : '';
        $scope.fields.validPinNumber = UtilsService.checkIsNumber($scope.form.x4c_signaturepin);
        $scope.fields.messagePinNumber = !($scope.fields.validPinNumber) ? FORM_MESSAGES.INVALIDPINNUMBER : '';
      }
      if($scope.form.contact !== undefined && $scope.form.contact !== '') {
        $scope.form.contact = $scope.form.contact.replace(/ +/g, ' ');
      }
      if($scope.form.contact !== undefined && $scope.form.contact !== '') {
        $scope.fields.validContact = UtilsService.checkContact($scope.form.contact);
        $scope.fields.messageContact = !($scope.fields.validContact) ? FORM_MESSAGES.INVALIDCONTACT : '';
      }
      if($scope.form.contactphone !== undefined && $scope.form.contactphone !== '') {
        $scope.fields.validContactphone = UtilsService.checkContactPhone($scope.form.contactphone);
        $scope.fields.messageContactphone = !($scope.fields.validContactphone) ? FORM_MESSAGES.INVALIDCONTACTPHONE : '';
      }
      if($scope.aleGroups.length > 0) {
        checkEINAleGroup();
      }
      // (X4C003) Validation
      if($scope.monthly.value === 'true'){
        if($scope.form.all_tecount > 0){
          $scope.fields.validTECount = true;
        }
      }
      else{
        _.each($scope.arrayMonthly, function(element){
          if($scope.form[element.prefix + '_tecount'] > 0){
            $scope.fields.validTECount = true;
          }
        });
      }
      if(!$scope.internalParII) {
        $scope.fields.validTECount = true;
        $scope.fields.messageTECount = !($scope.fields.validTECount) ? FORM_MESSAGES.TECOUNT : '';
      }
      else{
        $scope.fields.messageTECount = !($scope.fields.validTECount) ? FORM_MESSAGES.TECOUNT : '';
      }
    };

    var checkEINAleGroup = function(){
      for(var i = 0; i < $scope.aleGroups.length; i++){
        $scope.fields.validEIN = (UtilsService.checkNineCharacters($scope.aleGroups[i].ein) && UtilsService.checkIsNumber($scope.aleGroups[i].ein));
        $scope.fields.messageEIN = !($scope.fields.validEIN) ? FORM_MESSAGES.INVALIDEIN : '';
        if(!$scope.fields.validEIN){
          return;
        }
      }
    };

    var checkFields16 = function(){
      if($scope.internalParII) {
        // (X4C001) Validation
        if($scope.form.x4c_qlfyoffermethodtrind || $scope.form.x4c_pctoffermethodind){
          if($scope.monthly.value === 'true'){
            if($scope.form.all_mecoindicator === 'true'){
              $scope.fields.validMECIndicator = true;
            }
          }
          else{
            _.each($scope.arrayMonthly, function(element){
              if($scope.form[element.prefix + '_mecoindicator'] === 'true'){
                $scope.fields.validMECIndicator = true;
              }
            });
          }
          $scope.fields.messageMECIndicator = !($scope.fields.validMECIndicator) ? FORM_MESSAGES.MECOINDICATOR : '';
        }
        else{
          $scope.fields.validMECIndicator = true;
        }

        // (X4C002) Validation
        if(!$scope.form.x4c_pctoffermethodind){
          if($scope.monthly.value === 'true'){
            if($scope.form.all_fecount > 0){
              $scope.fields.validFECount = true;
            }
          }
          else{
            _.each($scope.arrayMonthly, function(element){
              if($scope.form[element.prefix + '_fecount'] > 0){
                $scope.fields.validFECount = true;
              }
            });
          }
          $scope.fields.messageFECount = !($scope.fields.validFECount) ? FORM_MESSAGES.FECOUNT : '';
        }
        else{
          $scope.fields.validFECount = true;
        }

        // (X4C004) and (X4C005) Validation
        if($scope.data.optionFour === 'true'){
          if($scope.monthly.value === 'true'){
            if($scope.form.all_agindicator !== false && $scope.form.all_agindicator !== undefined){
              $scope.fields.validAGIndicator = true;
            }
          }
          else{
            _.each($scope.arrayMonthly, function(element){
              if($scope.form[element.prefix + '_agindicator'] !== false && $scope.form[element.prefix + '_agindicator'] !== undefined){
                $scope.fields.validAGIndicator = true;
              }
            });
          }
          $scope.fields.messageAGIndicator = !($scope.fields.validAGIndicator) ? FORM_MESSAGES.AGINDICATOR : '';
        }
        else{
          $scope.fields.validAGIndicator = true;
          if($scope.monthly.value === 'true'){
            if($scope.form.all_agindicator === true){
              $scope.fields.validNOAGIndicator = true;
            }
          }
          else{
            _.each($scope.arrayMonthly, function(element){
              if($scope.form[element.prefix + '_agindicator'] === true){
                $scope.fields.validNOAGIndicator = true;
              }
            });
          }
          $scope.fields.messageNOAGIndicator = ($scope.fields.validNOAGIndicator) ? FORM_MESSAGES.NOAGINDICATOR : '';
        }

        // (X4C006) and (X4C007) Validation
        if($scope.form.x4c_sect4980hreliefind){
          if($scope.monthly.value === 'true'){
            if($scope.form.all_s4trindicator === undefined || $scope.form.all_s4trindicator === ''){
              $scope.fields.validS4TrIndicator = true;
            }
          }
          else{
            var reliefInd;
            _.each($scope.arrayMonthly, function(element){
              if(reliefCondition($scope.form[element.prefix + '_s4trindicator'])){
                reliefInd = $scope.form[element.prefix + '_s4trindicator'];
              }
            });
            if(reliefInd !== undefined){
              _.each($scope.arrayMonthly, function(element){
                if(reliefCondition($scope.form[element.prefix + '_s4trindicator'])){
                  if($scope.form[element.prefix + '_s4trindicator'] !== reliefInd){
                    $scope.fields.validS4TrIndicator = true;
                  }
                }
              });
            }
            else{
              $scope.fields.validS4TrIndicator = true;
            }
          }
          $scope.fields.messageS4TrIndicator = ($scope.fields.validS4TrIndicator) ? FORM_MESSAGES.S4TRINDICATOR : '';
        }
        else{
          if($scope.monthly.value === 'true'){
            if($scope.form.all_s4trindicator !== '' && $scope.form.all_s4trindicator !== undefined){
              $scope.fields.validNOS4TrIndicator = true;
            }
          }
          else{
            _.each($scope.arrayMonthly, function(element){
              if(reliefCondition($scope.form[element.prefix + '_s4trindicator'])){
                $scope.fields.validNOS4TrIndicator = true;
              }
            });
          }
          $scope.fields.messageNOS4TrIndicator = ($scope.fields.validNOS4TrIndicator) ? FORM_MESSAGES.NOS4TRINDICATOR : '';
        }

        // (0034) Payer Validation
        if($scope.form.x4c_totalformsfiled > 0){
          $scope.fields.validTotalFormsFiled = true;
        }
        $scope.fields.messageTotalFormsFiled = !($scope.fields.validTotalFormsFiled) ? FORM_MESSAGES.TOTALFORMSFILED : '';
      }
      else{
        $scope.fields.validMECIndicator = true;
        $scope.fields.validFECount = true;
        $scope.fields.validAGIndicator = true;
        $scope.fields.validTotalFormsFiled = true;
      }
      if($scope.internalParI){
        // (0036) Payer Validation
        if($scope.form.ptin !== $scope.form.x4c_govtentityemployer){
          $scope.fields.validGovtEntityEmployer = true;
        }
        $scope.fields.messageGovtEntityEmployer = !($scope.fields.validGovtEntityEmployer) ? FORM_MESSAGES.GOVTENTITYEMPLOYER : '';

        // (0038) Payer Validation
        if($scope.form.x4c_govtentityemployer !== undefined && $scope.form.x4c_govtentityemployer !== ''){
          var govtEntityEmployer = _.where($scope.payers, {ptin: $scope.form.x4c_govtentityemployer});
          if(govtEntityEmployer.length > 0){
            if(govtEntityEmployer[0].contactphone != undefined){
              if(govtEntityEmployer[0].contact !== '' && govtEntityEmployer[0].contactphone.length === 10 && govtEntityEmployer[0].ptintype === '1'){
                $scope.fields.validDataGovtEntityEmployer = true;
              }
            }
          }
          $scope.fields.messageDataGovtEntityEmployer = !($scope.fields.validDataGovtEntityEmployer) ? FORM_MESSAGES.DATAGOVTENTITYEMPLOYER : '';
        }
        else{
          $scope.fields.validDataGovtEntityEmployer = true;
        }
      }
      else{
        $scope.fields.validGovtEntityEmployer = true;
        $scope.fields.validDataGovtEntityEmployer = true;
      }
    };

    var reliefCondition = function(relief){
      return (relief !== undefined && relief !== '');
    };

    $scope.addDge = function(){
      MsgBetweenCtrlService.data.parent = {
        formPage: $scope.formPage,
        selectedEmployer: undefined,
        data: $scope.data,
        form: $scope.form,
        fields: $scope.fields
      };
      $scope.employerAction = 'add';
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: 'app/views/employer/modals/form-employer.html',
        controller: 'EmployerController',
        preserveScope: true,
        locals: {
          currentEmployer: undefined
        }
      });
    };

    changePage('firstStep');
    if(dataController !== undefined){
      changePage(dataController.formPage);
      $scope.data = dataController.data;
      $scope.form = dataController.form;
      $scope.nexStep();
      $scope.fields = dataController.fields;
      MsgBetweenCtrlService.clearData();
      $timeout(
        function(){
          $scope.form.x4c_govtentityemployer = dataController.selectedEmployer;
          LayoutService.setSelectBoxChange('#dge-selected',dataController.selectedEmployer, '#dge-label');
        }, 1000
      );
    }

    $scope.doesHaveOwnPin = $scope.form.x4c_signaturepin ? true : false;

    $scope.cleanOwnSignatureFields = function(){
      $scope.form.x4c_signaturepin = '';
      $scope.form.x4c_signaturetitle = '';
      $scope.form.x4c_signaturedate = '';
    }

  }
]);
